import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

// 2- config
import {AppConfig} from './environments/AppConfig';

AppConfig.setup();
console.log('environment.name', environment.name);
if (environment.name === 'NOTSET') {
	alert('cannot find configuration, application will not work');
}

// rewrite environment by docker
const cfg = window['EnvConfig'];
if (cfg) {
	console.log('env variable override');
	environment.name = cfg['ENVIRONMENT_NAME'];
	environment.production = cfg['ENVIRONMENT_IS_PRODUCTION'] === 'yes' ? true : false;
	environment.override = cfg['OVERRIDE_TOKEN'] || cfg['OVERRIDE_LOGIN'] || cfg['OVERRIDE_GROUPS'] ? {
		token: cfg['OVERRIDE_TOKEN'],
		groups: cfg['OVERRIDE_LOGIN'],
		login: cfg['OVERRIDE_GROUPS']
	} : null;
	environment.api = {
		authentication: {
			url: cfg['API_AUTHENTICATION_URL']
		},
		qar: {
			url: cfg['API_QAR_URL']
		}
	};
	environment.okta = {
		issuer: cfg['OKTA_ISSUER_URL'],
		redirectUri: cfg['OKTA_REDIRECT_URL'],
		loginUri: cfg['OKTA_LOGIN_URL'],
		clientId: cfg['OKTA_CLIENT_ID'],
		pkce: true
	};
}

console.log('environment', environment);

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
	.catch(err => console.error(err));
